module.exports = __webpack_public_path__ + "img/floatbgc.9e969a7f.png";